export const TENANT_OBJECT_COLLECTION = "$tenants";
